import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { UserFieldsFragmentDoc } from '../../../fragments/userFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequirementAuditLogQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type RequirementAuditLogQuery = { __typename?: 'Query', requirement?: { __typename?: 'Requirement', id: string, auditLog: Array<{ __typename: 'AuditLog', entityId: string, changeSetId: any, entityType: string, entityOperation: Types.EntityOperation, createdAt: any, id: string, entity?: { __typename: 'ActiveTypeMarket', id: string } | { __typename: 'AttachmentCategory', id: string } | { __typename: 'AuditLog', id: string } | { __typename: 'BodyworkVariant', id: string } | { __typename: 'Category', id: string } | { __typename: 'Convolute', id: string } | { __typename: 'Country', id: string } | { __typename: 'DocumentSource', id: string } | { __typename: 'DriveVariant', id: string } | { __typename: 'EngineVariant', id: string } | { __typename: 'GdprRule', id: string } | { __typename: 'GearboxVariant', id: string } | { __typename: 'GetexRegulation', id: string } | { __typename: 'GlobalAnnouncement', id: string } | { __typename: 'IcsCode', id: string } | { __typename: 'Keyword', id: string } | { __typename: 'Market', id: string } | { __typename: 'PermissionGroup', id: string } | { __typename: 'PogisDocument', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionCategory', id: string } | { __typename: 'Reference', id: string } | { __typename: 'Regulation', id: string } | { __typename: 'RegulationCluster', id: string } | { __typename: 'RegulatoryDocument', id: string } | { __typename: 'Requirement', id: string } | { __typename: 'Simulation', id: string } | { __typename: 'SimulationVehicleProject', id: string } | { __typename: 'StandardPlusPcmsCluster', id: string } | { __typename: 'Subscription', id: string } | { __typename: 'SystemLevel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'User', id: string } | { __typename: 'VehicleCategory', id: string } | { __typename: 'VehicleProject', id: string } | { __typename: 'VexCluster', id: string } | { __typename: 'Vko', id: string } | null, change: { __typename: 'AuditLogChange', value?: any | null, oldValue?: any | null, nodeId?: string | null, oldNodeId?: string | null, type: string, key: string, path: string }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> } | null };


export const RequirementAuditLogDocument = gql`
    query RequirementAuditLog($id: ID!) {
  requirement(id: $id) {
    id
    auditLog {
      entityId
      changeSetId
      entity {
        id
        __typename
      }
      change {
        value
        oldValue
        nodeId
        oldNodeId
        type
        key
        path
        __typename
      }
      entityType
      entityOperation
      createdAt
      createdBy {
        ...UserFields
      }
      id
      __typename
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useRequirementAuditLogQuery__
 *
 * To run a query within a React component, call `useRequirementAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequirementAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequirementAuditLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequirementAuditLogQuery(baseOptions: Apollo.QueryHookOptions<RequirementAuditLogQuery, RequirementAuditLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequirementAuditLogQuery, RequirementAuditLogQueryVariables>(RequirementAuditLogDocument, options);
      }
export function useRequirementAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequirementAuditLogQuery, RequirementAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequirementAuditLogQuery, RequirementAuditLogQueryVariables>(RequirementAuditLogDocument, options);
        }
export type RequirementAuditLogQueryHookResult = ReturnType<typeof useRequirementAuditLogQuery>;
export type RequirementAuditLogLazyQueryHookResult = ReturnType<typeof useRequirementAuditLogLazyQuery>;
export type RequirementAuditLogQueryResult = Apollo.QueryResult<RequirementAuditLogQuery, RequirementAuditLogQueryVariables>;